import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { TenantOverviewPage } from '@/pages/tenants/detail/TenantOverviewPage'

const TenantOverviewSearchSchema = z.object({
  tab: z.enum(['overview', 'backups']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/tenants/$id/')({
  validateSearch: TenantOverviewSearchSchema,
  beforeLoad: ({ params, search }) => {
    if (search.tab === 'backups') {
      throw redirect({ to: '/tenants/$id/backups', params, replace: true })
    }
  },
  component: TenantOverviewPage,
})
